import $ from 'jquery'

export class MenuLang {

  constructor () {
    this.$body = $('body')
    this.$container = $('.menu-lang')
    this.contentSelector = '.menu-lang-content'
    this.hasAjaxForMenuLang = false

    this.$body.on('click', '.menu-lang-header button', this.handleClickCloseMenuLang.bind(this))
    this.$body.on('click', '.button-open-menu-lang', this.handleClickOpenMenuLang.bind(this))
  }

  handleClickCloseMenuLang (e) {
    e.preventDefault()
    this.closeMenuLang()
  }

  handleClickOpenMenuLang (e) {
    e.preventDefault()
    this.openMenuLang()

    if (this.$container.find(this.contentSelector).length === 0) {
      this.getMenuLang()
    }
  }

  openMenuLang () {
    this.$container.addClass('open')
  }

  closeMenuLang () {
    this.$container.removeClass('open')
  }

  getMenuLang () {
    if (this.hasAjaxForMenuLang) return

    let data = {
      'action': 'vah_get_menu_lang'
    }

    $.ajax({
      url: ajax_url.ajax_url,
      data: data,
      type: 'POST',
      dataType: 'json',
      success: this.getAjaxForMenuLangSuccess.bind(this),
    })
  }
  getAjaxForMenuLangSuccess (data) {
    if (data.success) {
      this.$container.html(data.data.menu)
      this.hasAjaxForMenuLang = true
    }
  }
}
